"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vitalSigns = void 0;
var vitalSigns = {
  	"viewBox": "0 0 100 100",
  	"children": [{
		"name": "path",
		"attribs": {
			"d": "M94.8,6c-0.1-2.3-1-3.1-3.1-3.1c-5.6,0-11.2,0-16.9,0c-1.5,0-2.4,0.9-2.5,2.3c-0.1,0.9-0.1,1.8-0.2,2.7"+
            "c-0.1,1-0.5,1.4-1.6,1.4C67,9.5,63.4,9.8,59.8,10c-0.3,0-0.6,0.1-0.9,0.1c-2.8,0.5-5.6,1.5-8.4,1.5c-3.5,0-7-0.8-10.5-1.2"+
            "c-3.2-0.4-6.5-0.7-9.7-1.1c-0.8-0.1-1.7,0-2.4,0C27.8,9,27.7,9,27.7,8.9c0-1.1,0-2.2-0.1-3.3c-0.1-1.5-1.2-2.7-2.7-2.8"+
            "c-5.7,0-11.4-0.1-17.2,0C6.1,2.9,5,4,5,5.9c0.1,3.9,0,7.8,0,11.6c0,1.7,0.8,2.6,2.5,2.6c5.9,0,11.7,0,17.6,0c1.6,0,2.5-1,2.5-2.6"+
            "c0-1.1,0-2.2,0-3.5c3.9,0.4,7.4,0.8,11,1.2c-0.5,0.7-1.1,1-1.6,1.2c-4.5,2.4-8.6,5.2-11.5,9.5c-2,3-3.6,6.2-3.9,9.8"+
            "c-0.3,3.8-0.7,7.6-0.3,11.4c0.3,3.2,1.3,6.3,2.3,9.4c1.1,3.5,2.3,7,4.7,9.9c3.6,4.5,8.2,7.3,13.8,8.5c1.1,0.2,1.5,0.8,1.5,1.9"+
            "c0,4.2-0.1,8.3,0,12.5c0,1.5,0,3.2,0.5,4.6c0.9,2.4,4,3.7,6.5,3c2-0.6,4.1-2.8,4-5.5c-0.1-4.9,0-9.8-0.1-14.8c0-1,0.4-1.5,1.2-1.7"+
            "c3.5-0.6,6.6-2.2,9.4-4.3c3.5-2.6,6.3-5.7,7.8-9.8c0.8-2.1,1.2-4.3,1.9-6.4c1.4-4,2.3-8.1,2.4-12.4c0-3.6-0.1-7.1-1.5-10.5"+
            "c-2.2-5.4-5.7-9.9-10.8-13c-1.8-1.1-3.7-2.2-5.8-3.4c1.8-0.3,3.4-0.5,5-0.7c1.3-0.2,2.6-0.2,3.8-0.4c3.7-0.6,4-0.4,4.2,3.2"+
            "c0,0.1,0,0.3,0,0.4c0.2,1.6,0.7,2.2,2.4,2.2c5.8,0,11.6,0,17.5,0c1.7,0,2.8-1,2.8-2.9C95.1,13.6,95,9.8,94.8,6z M22.8,15.2"+
            "c-4.4,0-8.6,0-13,0c0-2.2,0-4.1,0-6.1c0-0.8,0.3-1.1,1-1.1c3.6,0,7.2,0,10.9,0c0.4,0,1,0.5,1,0.7C22.8,10.9,22.8,13,22.8,15.2z"+
             "M66.6,26.7c2.9,3,4.6,6.6,5.4,10.8c0.8,4.4-0.1,8.4-0.8,12.6c-0.2,0.9-0.7,1.3-1.6,1.1c-1.4-0.3-2.9-0.5-4.3-0.9"+
            "c-1.6-0.5-1.9-0.3-2.4,1.3c-0.9,2.8-1.2,5.9-3.5,8.2c-2.1,2-4.6,2.9-7.4,3.4c-2,0.4-3.9,0.3-5.9,0c-4.5-0.7-8.8-3.5-10.1-8.5"+
            "c-0.4-1.7-1-3.4-1.5-5.1c-2.6,0.7-4.8,1.3-7.1,1.9c-1.3-4.3-1.7-8.3-1.4-12.5c0.5-7.4,4.6-12.7,10.7-16.4"+
            "c3.2-1.9,6.7-3.2,10.2-4.7c2.1-0.9,4.3-0.3,6.3,0.5C58.1,20.4,62.9,22.7,66.6,26.7z M89.7,15.2c-4.1,0-8.3,0-12.5,0"+
            "c0-2.3,0-4.7,0-7.1c4.2,0,8.3,0,12.5,0C89.7,10.5,89.7,12.8,89.7,15.2z",
		}
	}]
};
exports.vitalSigns = vitalSigns;